import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import classes from "./RightBar.module.css";

const RightBar = (props) => {
  const history = useHistory();
  let userName = null,
    token = null,
    dealership_type = null,
    profilePic = null;
  if (props.currentUser) {
    userName = props.currentUser.name;
    token = props.currentUser.pcari_token_balance;
    profilePic = props.currentUser.profile_picture;
    dealership_type = props.currentUser.dealership_type;
  }

  return (
    <div className={classes.RightBar}>
      <div className={classes.DealerInfo}>
        <p>
          Hello <br />
          <strong>{userName}</strong>
        </p>
        <img src={profilePic} alt="profile" />
      </div>

      <button
        className={classes.Btn}
        onClick={(event) => history.push("/Feature")}
      >
        Become a Featured Dealer
      </button>

      <div className={classes.tokenCard}>
        {/* <small className={classes.pcari}>pcari</small> */}
        <div className={classes.Row}>
          <p>
            status
            <br />
            Active{" "}
          </p>
          <p>
            Account type
            <br />
            {dealership_type}
          </p>
        </div>
        <div className={classes.Row}>
          <p>
            Token Balance
            <br />
            {token}
          </p>
          <button
            onClick={(event) => history.push("/TopUp")}
            className={`${classes.Btn} ${classes.TopUP}`}
          >
            Top Up
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.Auth.currentUser,
  };
};

export default connect(mapStateToProps)(RightBar);
